import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLang } from '../hooks/useLang';
import { pickLocalized } from '../i18n';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Agence = () => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const [philosophy, setPhilosophy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPhilosophy = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/philosophy`);
        if (!response.ok) throw new Error('Failed to fetch philosophy');
        const data = await response.json();
        setPhilosophy(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching philosophy:', err);
        setLoading(false);
      }
    };
    fetchPhilosophy();
  }, []);

  const phTitle = philosophy ? pickLocalized(philosophy, 'title', lang) : '';
  const phDescription = philosophy ? pickLocalized(philosophy, 'description', lang) : '';
  const phFullText = philosophy ? pickLocalized(philosophy, 'fullText', lang) : '';

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-grow pt-32 pb-20 px-8 lg:px-16">
        <div className="max-w-[1200px] mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-wide mb-16">{t('agency.title')}</h1>

          {loading ? (
            <p className="text-center text-gray-500">{t('common.loading')}</p>
          ) : philosophy ? (
            <div className="mb-16">
              <h2 className="text-3xl font-light mb-8">{phTitle}</h2>
              <p className="text-lg font-light text-gray-700 mb-6 leading-relaxed">{phDescription}</p>
              <div className="prose prose-lg max-w-none">
                <p className="text-base font-light text-gray-600 leading-relaxed whitespace-pre-line">{phFullText}</p>
              </div>
            </div>
          ) : null}

          <div className="border-t border-gray-200 pt-16 mt-16">
            <h2 className="text-2xl font-light mb-8">{t('agency.contact')}</h2>
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h3 className="text-lg font-light mb-4 text-gray-700">{t('agency.headOffice')}</h3>
                <p className="text-base font-light leading-relaxed">5, rue Danton<br />93100 Montreuil</p>
              </div>
              <div>
                <h3 className="text-lg font-light mb-4 text-gray-700">{t('agency.office')}</h3>
                <p className="text-base font-light leading-relaxed">30, Allée Vivaldi<br />75012 PARIS</p>
              </div>
            </div>
            <div className="mt-8">
              <p className="text-base font-light">
                <span className="text-gray-700 mr-4">{t('agency.phone')}</span>
                <a href="tel:+33617750880" className="hover:text-[#d94e47] transition-colors duration-300">06 17 75 08 80</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Agence;
